// Dependencies
import React, {useState} from 'react'
import {connect} from 'react-redux'
import firebase from 'firebase/compat/app'

// Actions
import {storePayload} from '../actions/storePayload'
import {signIn} from '../actions/signIn.js'

// Components
import {Input, Button, Switch, Icon} from '@lazarusai/forms-ui-components'
import MFA from './MFA.js'

// Images
import logo from '../images/logo.png'

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import '../styles/AuthModal.css'
import {signInWithGoogle} from '../actions/signInWithGoogle.js'

function AuthModal(props) {
  const [signInForm, setSignInForm] = useState({
    username: '',
    password: '',
  })

  function onChangeSignIn(e) {
    setSignInForm({
      ...signInForm,
      [e.target.name]: e.target.value,
    })
  }

  function onSubmitSignIn(e) {
    e.preventDefault()
    props.signIn(signInForm, props.database)
  }

  function onChangeCheckBox() {
    setSignInForm({
      ...signInForm,
      isSaveCred: !signInForm.isSaveCred,
    })
  }

  function onClickForgotPassword(e) {
    e.stopPropagation()
    if (signInForm.username) {
      firebase
          .auth()
          .sendPasswordResetEmail(signInForm.username)
          .then((res) => {
            props.storePayload({
              userMessage: 'Please check your email to change your password.',
              notificationType: 1,
              notificationIcon: 'check',
            })
          })
          .catch((err) => {
            props.storePayload({
              userMessage: 'Email not found. Please try again.',
              notificationType: 2,
              notificationIcon: 'warning',
            })
          })
    } else {
      props.storePayload({
        userMessage: 'Please include your email.',
        notificationType: 2,
        notificationIcon: 'warning',
      })
    }
  }

  const signInFormRender = (
    <main>
      <form
        onSubmit={onSubmitSignIn}
        id='sign-in-form'
      >
        <Input
          label='Email'
          key={3}
          name='username'
          id='username'
          type='text'
          autoComplete={false}
          theme={props.theme}
          value={signInForm.username}
          onChange={onChangeSignIn}
        />
        <Input
          label='Password'
          key={4}
          name='password'
          id='password'
          inputType='password'
          autoComplete={false}
          theme={props.theme}
          value={signInForm.password}
          onChange={onChangeSignIn}
        />
        <div className='checkbox-container'>
          <Switch
            type='checkbox'
            name='isSaveCred'
            id='isSaveCred'
            theme={props.theme}
            label='Remember me for 30 days'
            className='checkbox'
            onChange={onChangeCheckBox}
            value={signInForm.isSaveCred}
            checked={signInForm.isSaveCred}
            form={'sign-inform'}
          />
        </div>
        <Button
          type={1}
          text='Sign In'
          theme={props.theme}
          buttonType='submit'
        />
        <div
          className='button-auth-row'
        >
          <Button
            type={1}
            text='Sign In With Google'
            theme={props.theme}
            onClick={(e) => {
              e.preventDefault()
              props.signInWithGoogle(props.database, signInForm.isSaveCred)
            }}
            icon={
              <Icon
                icon={'google-outline'}
              />
            }
            iconPosition={'right'}
          />
          <Button
            type={9}
            text='Forgot Password'
            theme={props.theme}
            onClick={(e) => {
              e.preventDefault()
              onClickForgotPassword(e)
            }}
          />
        </div>
      </form>
    </main>
  )

  return (
    <div
      className={`${'auth-modal'}`}
    >
      <header>
        <img src={logo} alt='Lazarus' />
      </header>
      <div>
        {props.onMFATab ? <MFA /> : signInFormRender}
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  cookies: ownProps.cookies,
  database: state.firebaseReducer.database,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  theme: state.userReducer.theme,
  onMFATab: state.userReducer.onMFATab, // MFA related
})

export default connect(
    mapStateToProps,
    {storePayload, signIn, signInWithGoogle},
)(AuthModal)
